/* AF back in stock (Klaviyo client API). 2026-09-27.
One <af-bis> per product form. Shows itself only while the selected variant is sold out.
Listens to the theme's variant change (pubsub) and to the hidden variant id input. */
(() => {
if (window.customElements.get('af-bis')) return;

const API = 'https://a.klaviyo.com/client/';
const REVISION = '2024-10-15';
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const TEXT = {
bad: 'נראה שכתובת המייל לא תקינה, בדקו אותה ונסו שוב.',
err: 'משהו השתבש, נסו שוב בעוד רגע.',
};

class AfBis extends HTMLElement {
connectedCallback() {
if (this._ready) return;
this._ready = true;
try {
this.map = JSON.parse(this.querySelector('[data-af-bis-variants]').textContent);
} catch (e) {
this.map = {};
}
this.variantId = String(this.dataset.variant || '');
this.form = this.querySelector('.af-bis__form');
this.msgEl = this.querySelector('.af-bis__msg');
this.doneEl = this.querySelector('.af-bis__done');
this.btn = this.querySelector('.af-bis__btn');
this.form.addEventListener('submit', (e) => this.onSubmit(e));

if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
this._unsub = window.subscribe(window.PUB_SUB_EVENTS.variantChange, (ev) => {
const d = ev && ev.data;
if (!d || String(d.sectionId) !== String(this.dataset.section)) return;
this.setVariant(d.variant ? d.variant.id : null);
});
}
const scope = this.parentElement || document;
this.idInput = scope.querySelector('product-form input[name="id"]');
if (this.idInput) {
this._onId = () => this.setVariant(this.idInput.value);
this.idInput.addEventListener('change', this._onId);
}
this.setVariant(this.variantId);
}

disconnectedCallback() {
if (this._unsub) this._unsub();
if (this.idInput && this._onId) this.idInput.removeEventListener('change', this._onId);
this._ready = false;
}

setVariant(id) {
const key = id == null ? '' : String(id);
if (key !== this.variantId) {
this.variantId = key;
this.reset();
}
const soldOut = key !== '' && this.map[key] === false;
this.hidden = !soldOut;
}

reset() {
this.form.hidden = false;
this.doneEl.hidden = true;
this.showMsg('');
}

showMsg(text) {
this.msgEl.textContent = text;
this.msgEl.hidden = !text;
}

busy(on) {
this.btn.disabled = on;
this.classList.toggle('af-bis--busy', on);
}

post(path, body) {
return fetch(API + path + '?company_id=' + encodeURIComponent(this.dataset.company), {
method: 'POST',
headers: { 'content-type': 'application/json', revision: REVISION },
body: JSON.stringify(body),
});
}

async onSubmit(e) {
e.preventDefault();
const email = (this.form.elements.email.value || '').trim();
if (!EMAIL_RE.test(email)) {
this.showMsg(TEXT.bad);
this.form.elements.email.focus();
return;
}
if (!this.variantId) return;
this.showMsg('');
this.busy(true);
try {
const res = await this.post('back-in-stock-subscriptions/', {
data: {
type: 'back-in-stock-subscription',
attributes: {
profile: { data: { type: 'profile', attributes: { email } } },
channels: ['EMAIL'],
},
relationships: {
variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + this.variantId } },
},
},
});
if (!res.ok) throw new Error('bis ' + res.status);

const wantsMarketing = this.form.elements.marketing && this.form.elements.marketing.checked;
if (wantsMarketing && this.dataset.list) {
// Revision 2024-10-15: posting the email to the list IS the email marketing consent.
// A "subscriptions" object on the profile is rejected with 400 (fixed 2026-09-27 after live test).
this.post('subscriptions/', {
data: {
type: 'subscription',
attributes: {
custom_source: 'Back in stock form',
profile: { data: { type: 'profile', attributes: { email } } },
},
relationships: { list: { data: { type: 'list', id: this.dataset.list } } },
},
}).catch(() => {});
}

this.form.hidden = true;
this.doneEl.hidden = false;
this.form.reset();
} catch (err) {
this.showMsg(TEXT.err);
} finally {
this.busy(false);
}
}
}

window.customElements.define('af-bis', AfBis);
})();
